export { default } from './Menu'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Icons/Menu/index.js